import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Import slices
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import uiReducer from './slices/uiSlice';
import paymentReducer from './slices/paymentSlice';
import forexReducer from './slices/forexSlice';
import invoiceReducer from './slices/invoiceSlice';
import previousCloseReducer from './slices/previousCloseSlice';
import aggregateReducer from './slices/aggregateSlice';
import apiLogsReducer from './slices/apiLogsSlice';
import adminInvoiceReducer from './slices/adminInvoiceSlice'; // Add this line

// Persist configuration for auth
const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['user', 'isAuthenticated'], // Only persist user and auth status
};

// Persist configuration for user data
const userPersistConfig = {
  key: 'user',
  storage,
  whitelist: ['profile'], // Only persist profile data
};

// Create persisted reducers
const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedUserReducer = persistReducer(userPersistConfig, userReducer);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    user: persistedUserReducer,
    ui: uiReducer, // UI state doesn't need persistence
    payment: paymentReducer,
    forex: forexReducer,
    invoices: invoiceReducer,
    previousClose: previousCloseReducer,
    aggregate: aggregateReducer,
    apiLogs: apiLogsReducer,
    adminInvoices: adminInvoiceReducer, // Add this line
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/PAUSE',
          'persist/PURGE',
          'persist/REGISTER',
          'persist/FLUSH',
        ],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

// Export types for TypeScript support (if needed)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;